import availablePaths from '../component/store/3d-image-paths.json';

export const getImgUrl = (product) => {
    const productImage = `${product?.marketManufacturer?.replaceAll(" ", "-").replaceAll("/", "-").replaceAll("#", "-")}_${product?.marketMpn?.replaceAll(" ", "-").replaceAll("/", "-").replaceAll("#", "-")}.png`;
    if (!availablePaths.includes(productImage)) {
        return `${window.location.origin}/3d-images/placeholder.png`;
    } else {
        return `${window.location.origin}/3d-images/${productImage}`;
    }
};